export default {
    props: {
        isHidden: { type: Boolean, default: false },
    },
}
